/**
 * /for-community page localized copy.
 *
 * Re-export shim over /locales/{en,ht,fr,es}.json (under the
 * `for_community` key). See /locales/README.md.
 */
import en from '../locales-shared/en.json'
import ht from '../locales-shared/ht.json'
import fr from '../locales-shared/fr.json'
import es from '../locales-shared/es.json'
import ptBR from '../locales-shared/pt-BR.json'
import zhHans from '../locales-shared/zh-Hans.json'

const COPY = {
  en: en.for_community,
  ht: ht.for_community,
  fr: fr.for_community,
  es: es.for_community,
  'pt-BR': ptBR.for_community,
  'zh-Hans': zhHans.for_community,
}

export default COPY
